import { C } from "../lib/theme";

export function Skeleton({ w = "100%", h = 16, r = 8, style }) {
  return (
    <div
      style={{
        width: w,
        height: h,
        borderRadius: r,
        background: `linear-gradient(90deg, ${C.cream} 0%, ${C.dustLt} 50%, ${C.cream} 100%)`,
        backgroundSize: "200% 100%",
        animation: "kapioShimmer 1.4s ease-in-out infinite",
        ...style,
      }}
    />
  );
}
